import * as angular from "angular";

function fileDownloader() {
  return function (fileData, fileName, contentType) {

    const blob = new Blob([fileData], {type: contentType});
    const downloadUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = downloadUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
  }
}

angular
  .module('bringoz.admin.commons')
  .service('fileDownloader', fileDownloader);
